// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__XcnKH","errors":"Errors_errors__2EQ6m"};